import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store.js'
import 'nprogress/nprogress.css'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../node_modules/@fortawesome/fontawesome-free/css/all.min.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import BackButton from './components/BackButton.vue'
import NextButton from './components/NextButton.vue'
import Vuelidate from 'vuelidate'
import ValidationMessages from './mixins/validationMessages.js'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import VueGtag from "vue-gtag";

Vue.config.devtools = true

Vue.use(VueGtag, {
    config: { id: "UA-9077260-10" }
}, router);
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.component('datepicker', Datepicker)
Vue.component('back-button', BackButton)
Vue.component('next-button', NextButton)

Vue.prototype.moment = moment

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    DateFormatter(value) {
      return this.moment(value).format('MM/DD/YYYY')
    },
    CloseConfirmLeaveModal(resolve, event) {
      this.$EventBus.$off('confirm-leave')
      return store.dispatch('application/closeConfirmLeaveModal').then(() => {
        return resolve(event)
      })
    },
    ConfirmLeave() {
      return store.dispatch('application/openConfirmLeaveModal').then(() => {
        return new Promise(resolve => {
          this.$EventBus.$on('confirm-leave', e => {
            return this.CloseConfirmLeaveModal(resolve, e)
          })
        })
      })
    },
    DownloadFile(response) {
      const contentDisposition = response.headers['content-disposition'].match(/filename=(.*)?;/)
      const filename = contentDisposition ? contentDisposition[1].replace(/"/g, '') : `Download.pdf`
      if (typeof window.navigator.msSaveBlob !== 'undefined') {
        window.navigator.msSaveBlob(new Blob([response.data]), filename)
      } else {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
      }
    },
    ...ValidationMessages
  }
})

Vue.prototype.$EventBus = new Vue()
Vue.prototype.ConfirmLeaveEventTypes = {
  Cancel: 'cancel',
  Discard: 'discard',
  Save: 'save'
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')